
// A phone held upright: tabs at the bottom, one bar at the top and sheets from
// below. One definition, shared with the visitor pages.
export { PHONE_QUERY, usePhone } from "../../public/smallScreen";

/** Opened from its own icon on the home screen, with no browser around it. */
export function isStandalone(): boolean {
  if (typeof window === "undefined") return false;
  const nav = window.navigator as Navigator & { standalone?: boolean };
  return nav.standalone === true || !!window.matchMedia?.("(display-mode: standalone)")?.matches;
}
